module.exports = __webpack_public_path__ + "static/img/zhuanlifuwu.52485ee5.jpg";